module.exports = __webpack_public_path__ + "img/9791195177967.25a72c31.jpg";